import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../../Univ.js'
function OtReport(props) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [otData, setotData] = useState([]);
    const [status, setStatus] = useState({status: ''});
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    const handleUser = (event) => {
        setStatus({
            ...status,
            status: event.target.value
        });
    };
    useEffect(() => {
        fetchotData();
        const intervalId = setInterval(fetchotData, 2000);
        return () => clearInterval(intervalId);
    }, [startDate, endDate, status]);
    function fetchotData() {
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}ot-view/?start_date=${startDateString}&end_date=${endDateString}&status=${status.status}`;
        axios.get(url)
            .then(response => {
                setotData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const columns = [
        {
            field: 'ip__ip_id', headerName: 'IP ID',
            renderCell: (params) => (
                <Link to={`/ip-pat-view/${params.row.id}/`}>
                    {params.value}
                </Link>
            ),
            width: 120,
        },
        {field: 'ip__pat__pat_id', headerName: 'Pat Id', width: 100},
        {field: 'ip__pat__patient', headerName: 'Patient', width: 120},
        {
            field: 'status',
            headerName: 'Status',
            renderCell: (params) => {
                if (params.value === 0) {
                    return <span className="badge text-bg-danger rounded-pill">Cancelled</span>;
                } else if (params.value === 3) {
                    return <span className="badge text-bg-success rounded-pill">Completed</span>;
                } else if (params.value === 1) {
                    return <span className="badge text-bg-info rounded-pill">Waiting</span>;
                }
            },
            width: 90,
        },
        {field: 'surgeon', headerName: 'Surgeon', width: 90},
        {field: 'nurse', headerName: 'Nurse', width: 90},
        {field: 'anesthetist', headerName: 'Anesthetist', width: 90},
        {field: 'surg_time', headerName: 'Surgery On', width: 120},
        {field: 'pre_notes', headerName: 'Pre Notes', width: 150},
        {field: 'pre_time', headerName: 'Pre Time', width: 120},
        {field: 'post_notes', headerName: 'Post Notes', width: 150},
        {field: 'post_time', headerName: 'Post Time', width: 120},
        {field: 'comments', headerName: 'Comments', width: 120},
    ];
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> OT Report Date-wise</h3>
            <div className="row">
                <div className="col-md-6">
                    <label htmlFor="user" className="form-label">Select Date</label>
                    <div className="date-filter-container">
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="From Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />

                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            placeholderText="To Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />
                    </div>
                </div>
                <div className="col-md-6">
                    <div className="mb-4 mt-4">
                        <label htmlFor="status" className="form-label">Search by Status</label>
                        <select name="status" id="status" value={status.status} className="form-control"
                                onChange={(event) => handleUser(event)}>
                            <option value="">Select Status</option>
                            <option value="1">Pending</option>
                            <option value="3">Completed</option>
                            <option value="0">Cancelled</option>
                        </select>
                    </div>
                </div>

            </div>

            {otData.length > 0 ? (
                <div style={{height: 500, width: "100%"}}>
                    <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                        className="fa-solid fa-calendar-days"
                        aria-hidden="true" style={{color: 'red'}}></i> OT Report </h3>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={otData}
                              columns={columns}
                              pageSize={10}
                              slots={{
                                  toolbar: GridToolbar,
                              }}
                              autoHeight
                    />
                </div>
            ) : (
                <></>
            )}
        </section>
    )
}
export default OtReport;
